export const objectToJsonResponse = (data = {}, isError = false) => {
    return data;
}